export enum AnstellungEnum {
    OhneAnstellung = 'ohneAnstellung',
    Angestellt = 'angestellt',
    Selbststaendig = 'selbststaendig',
}

export const ACQUISITION_TYPES_WITHOUT_PROFESSION = [
    '0', // leer
    '1', // nicht erwerbstätig
    '41', // pensioniert
    '51', // erwebsunfaehig
    '61', // arbeitslos
    '71', // Hausmann / Hausfrau
];

export const ACUISITION_TYPES_ANGESTELLT = [
    '11', // in Ausbildung
    '21', // angestellt
    '81', // befristet / temporär
];
export const ACUISITION_TYPES_SELBSTSTAENDIG = [
    '31', // selbstständig
];
